import React, { Component } from 'react';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import '../../marketplace.css';

let state;

class Publicaciones extends Component {

  constructor(props) {
    super(props);
    this.state = {
      texto_comentario: '',
    };
  }

  handleLike = (publicacion_id, like_id) => {

    if (!like_id) {
      this.props.handleAddLike(publicacion_id);
    } else {
      this.props.handleRemoveLike(publicacion_id, like_id);
    }

  }

  handleComentarioChange = (e) => {
    this.setState({ texto_comentario: e.target.value })
  }

  handleAddComentario = (publicacion_id) => {

    this.props.handleAddComentario(publicacion_id, this.state.texto_comentario);
    this.setState({ texto_comentario: '' })

  }

  renderPublicaciones = (publicaciones, ver_mas) => {
    const { t } = this.props;

    return (
      <div className="">

        {publicaciones.map(
          (_, index) => this.renderPublicacion(publicaciones[index], index)
        )}

        <br />
        {ver_mas && <center onClick={this.props.handleVerMas} style={{ color: "#21b3b3" }}><a>Ver más</a></center>}
        {!ver_mas && <center>No se encontraron más publicaciones</center>}
      </div>
    );

  }

  renderPublicacion = (publicacion, index) => {

    let color_like = publicacion.usuario_like ? "#21b3b3" : '';
    let spin = publicacion.usuario_like ? "fa-beat" : '';
    return (
      <div key={index} className="row panel panel-default card-markeplace" style={{ border: '1px solid #d7d3d3',  boxShadow: '2px 4px #d9d9d9' }}>
        <div className="col-md-12 form-group panel-heading">
          <div className="col-md-12">
            <p><img className="usuario_imagen" alt="Imagen de usuario" src={publicacion.usuario_imagen} style={{ marginRight: '10px' }}></img><b>{publicacion.usuario_nombre}</b></p>
          </div>
        </div>
        <div className="col-md-12 form-group">
          <div className="panel-body">
            <p style={{whiteSpace: "pre-line"}}>{publicacion.texto}</p>
          </div>
          <div className="panel-body">
            {
              publicacion.publicacion_imagen &&
              <div className="panel-body">
                <img className="imagen_publicacion" alt="Imagen" src={publicacion.publicacion_imagen}></img>
              </div>
            }
          </div>
        </div>
        <div className="col-md-12 form-group panel-footer" style={{ background: '#fff' }}>

          <span onClick={() => this.handleLike(publicacion.id, publicacion.usuario_like)} style={{ color: color_like }}>
            <i className={"fa fa-lg fa-heart " + spin} />&nbsp;{' Me Gusta'}
          </span>
          <span data-toggle="collapse" href={"#collapseComentarios" + index} style={{ float: 'right' }}><i className="fa fa-lg fa-comments" />&nbsp;{publicacion.comentarios + ' Comentarios'}</span>
        </div>

        <div className="col-md-12 form-group-comentarios">
          <div className="comentarios collapse" id={"collapseComentarios" + index}>
            <div className="comentario" style={{ padding: '1% 3%' }}>
              <div className="comentario-personal">
                <img className="usuario_imagen imagen_agregar usuario_imagen_coment" alt="Imagen de usuario" src={this.props.user.picture}></img>
                <textarea value={this.state.texto_comentario} onChange={this.handleComentarioChange} className="round_textarea" rows="1" id="texto_agregar_comentario" placeholder="Comparte tu comentario" required=""></textarea>
                <button onClick={() => this.handleAddComentario(publicacion.id)} className="btn-coment mobile" ><i className="fa fa-commenting"></i></button>
                <button onClick={() => this.handleAddComentario(publicacion.id)} className="btn-coment pc" >Comentar</button>
              </div>
            </div>
            {publicacion.comentarios_contenido.map(
              (_, index) => this.renderComentarios(publicacion.comentarios_contenido[index], index)
            )}
          </div>
        </div>
      </div>

      // <div className="panel panel-default">
      //   <div className="panel-heading">
      //       <h4>
      //         <img className="usuario_imagen" alt="Imagen de usuario" src={publicacion.usuario_imagen}></img>
      //         &emsp;{publicacion.usuario_nombre}
      //       </h4>
      //   </div>
      //   <hr></hr>
      //   <div style={{paddingRight: '4%', paddingLeft: '4%'}} className="panel-body">
      //     <p>{publicacion.texto}</p>
      //   </div>
      //   {
      //     publicacion.publicacion_imagen && 
      //     <div className="panel-body">
      //       <img className="imagen_publicacion" alt="Imagen" src={publicacion.publicacion_imagen}></img>
      //     </div>
      //   }
      //   <hr></hr>
      //   <div className="panel-footer">
      //     <span data-toggle="collapse" href={"#collapseComentarios"+index}><i className="fa fa-lg fa-comments" />&nbsp;{publicacion.comentarios+' Comentarios'}</span>
      //     <span onClick={() => this.handleLike(publicacion.id,publicacion.usuario_like)} style={{float:'right',color:color_like}}>
      //       <i className={"fa fa-lg fa-heart "+spin} />&nbsp;{publicacion.likes+' Me Gusta'}
      //     </span>
      //   </div>

      //   <div className="comentarios collapse" id={"collapseComentarios"+index}>

      //     <div className="comentario">
      //       <img className="usuario_imagen imagen_agregar" alt="Imagen de usuario" src={this.props.user.picture}></img>
      //       <textarea value={this.state.texto_comentario} onChange={this.handleComentarioChange} className="round_textarea" style={{width: '75%' , marginLeft:'7%'}} rows="1" id="texto_agregar_comentario" placeholder="Comparte tu comentario" required=""></textarea>
      //       <span style={{float:'right'}}>
      //           <br></br><br></br>
      //           <button onClick={() => this.handleAddComentario(publicacion.id)} className="btn btn-info btn-sm">Comentar</button>
      //       </span>
      //     </div>

      //     {publicacion.comentarios_contenido.map(
      //       (_, index) => this.renderComentarios(publicacion.comentarios_contenido[index], index)
      //     )}
      //   </div>
      // </div>
    );
  }



  renderComentarios = (comentario, index) => {

    return (

      <div key={index} className="comentario col-md-12 form-group">
        <div className="col-md-1 form-groug">
          <img className="usuario_imagen_comentario" alt="Imagen de usuario" src={comentario.usuario_imagen}></img>
        </div>
        <div className="col-md-11 form-groug text_coment">
          <p><b>{comentario.usuario_nombre !== " " ? comentario.usuario_nombre : 'USUARIO MARKETPLACE'}</b></p>
          <p>{comentario.texto !== "" ? comentario.texto : '' }</p>
        </div>
        {/* <h4>
            <img className="usuario_imagen" alt="Imagen de usuario" src={comentario.usuario_imagen}></img>
            &emsp;{comentario.usuario_nombre}
          </h4>
          <p className="timestamp">{comentario.fecha}</p> {/*10/14/21, 01:46 PM
          <p>{comentario.texto}</p> */}
      </div>

    );
  }


  render() {
    const publicaciones = this.props.publicaciones;
    const ver_mas = this.props.ver_mas;
    return (
      <div>
        {publicaciones && this.renderPublicaciones(publicaciones, ver_mas)}
      </div>
    );
  }

}

export default translate('common')(Publicaciones);



// WEBPACK FOOTER //
// ./src/dashboard/profileUser/Publicaciones.js